/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';
import * as angular from 'angular';

/*
	Tracks which 'view' window has focus.
 */
angular.module('ticketspaceApp').factory('focusManager', function () {
	let registrations = ['plan', 'projectView'];
	let currentFocus = 'plan';

	function setFocus(focusValue) {
		return (currentFocus = focusValue);
	}

	function get() {
		return currentFocus;
	}

	function isValid(focusValue) {
		return registrations.indexOf(focusValue) >= 0;
	}

	function update(newFocusValue) {
		if (newFocusValue !== currentFocus && isValid(newFocusValue)) {
			return setFocus(newFocusValue);
		} else {
			return currentFocus;
		}
	}

	function match(matchWith) {
		return currentFocus === matchWith;
	}

	return {
		set: setFocus,
		get,
		update,
		match,
	};
});
